import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import account from "./modules/account";
import employeeSession from "./modules/employeeSession";
import admins from "./modules/admins";
import employees from "./modules/employees";
import companies from "./modules/companies";
import customers from "./modules/customers";
import products from "./modules/products";
import paymentSettings from "./modules/paymentSettings";
import paymentMethods from "./modules/paymentMethods";
import discounts from "./modules/discounts";
import bankAccounts from "./modules/bankAccounts";
import regions from "./modules/regions";
import specialDiscount from "./modules/specialDiscount";
import productCategories from "./modules/productCategories";
import extraProductRule from "./modules/extraProductRule";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appSettings: {
      projectName: "Sahaskop Saha Satış Uygulaması",
      tokenTime: 1,
    },
  },
  getters: {
    getAppSettings: (state) => {
      return state.appSettings;
    },
  },
  mutations: {},
  actions: {},
  modules: {
    app,
    account,
    employeeSession,
    admins,
    employees,
    companies,
    customers,
    products,
    productCategories,
    extraProductRule,
    regions,
    specialDiscount,
    discounts,
    bankAccounts,
    paymentMethods,
    paymentSettings,
  },
});
